import React from 'react';
import ServerMonitoring from './ServerMonitoring';

// 데이터베이스 전용 페이지 — ServerMonitoring 컴포넌트를 DB 모드로 재활용
export default function DatabaseMonitoring() {
  return <ServerMonitoring mode="database" />;
}
